module.exports = __webpack_public_path__ + "static/media/image 93.5cd2f45c.png";